import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=24306664"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=24306664&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24306664')) {
      api.createRecord('24306664', component.options)
    } else {
      api.reload('24306664', component.options)
    }
    module.hot.accept("./ErrorScreen.vue?vue&type=template&id=24306664", function () {
      api.rerender('24306664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseFlow/ErrorScreen.vue"
export default component.exports